import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FacebookButtonModalManager from '../../modals/manager/FacebookButtonModalManager';

import { updateLoginState } from 'components/external-integration/facebook/button';

import type { State } from 'types';

interface Props {
  creatorProfileId: number
}

const FacebookButtonInitialize: React.FC<Props> = ({
  creatorProfileId
}: Props) => {
  const dispatch = useDispatch();
  const buttonState = useSelector((state: State) => state.facebookButton);

  React.useEffect(() => {
    dispatch(updateLoginState(creatorProfileId));
  }, [buttonState]);

  return (
    <div className="facebook-button-initialize">
      <FacebookButtonModalManager
        creatorProfileId={creatorProfileId}
        buttonState={buttonState}
      />
    </div>
  );
};

export default FacebookButtonInitialize;
